/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiMemberDtoGenerateAddressLabelsPdfDto
 */
export interface WebApiMemberDtoGenerateAddressLabelsPdfDto {
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoGenerateAddressLabelsPdfDto
     */
    onlyWithoutEmail?: boolean;
}

/**
 * Check if a given object implements the WebApiMemberDtoGenerateAddressLabelsPdfDto interface.
 */
export function instanceOfWebApiMemberDtoGenerateAddressLabelsPdfDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoGenerateAddressLabelsPdfDtoFromJSON(json: any): WebApiMemberDtoGenerateAddressLabelsPdfDto {
    return WebApiMemberDtoGenerateAddressLabelsPdfDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoGenerateAddressLabelsPdfDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoGenerateAddressLabelsPdfDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onlyWithoutEmail': !exists(json, 'onlyWithoutEmail') ? undefined : json['onlyWithoutEmail'],
    };
}

export function WebApiMemberDtoGenerateAddressLabelsPdfDtoToJSON(value?: WebApiMemberDtoGenerateAddressLabelsPdfDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onlyWithoutEmail': value.onlyWithoutEmail,
    };
}

